module.exports = __webpack_public_path__ + "static/img/bg2@2x.0c8d9c05.png";